import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

const KEY_API_PUBLIC_URL = environment.ksaPassPublico;
@Injectable()
export class AuthInterceptor implements HttpInterceptor {

	constructor(private auth: AuthService, private router: Router) { }

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		let authReq = req.clone({
			headers: req.headers.set('Authorization', `${KEY_API_PUBLIC_URL}`)
		});
		if (this.auth.isToken()) {
			const authToken = this.auth.getToken();
			authReq = req.clone({
				headers: req.headers.set('Authorization', `Bearer ${authToken.token}`)
			});
		}
		if (this.urlsNoTokenPorPagina(this.router.url) || this.urlsNoTokenServiceEspecifico(req.url)) {

			return next.handle(authReq);
		}
		// Get the auth token from the service.
		try {
			return next.handle(authReq);
		} catch (error) {
			this.router.navigate(['login']);
		}
	}

	urlsNoTokenPorPagina(url: string) {
		return (url.startsWith('/home')) ||
			(url.startsWith('/contactenos')) ||
			(url.startsWith('/faq')) ||
			(url.startsWith('/legislacion')) ||
			(url.startsWith('/videosTutoriales')) ||
			(url.startsWith('/terminos')) ||
			(url.startsWith('/registrar'));
		// (url.indexOf('/recuperarContrasena') > -1) ||
		// (url === '/');
	}

	urlsNoTokenServiceEspecifico(url: string) {
		return (url.indexOf('/usuario/login') > -1);
	}
}
